/**
 ⚠️ Design System — Protected file
 Do not edit this file without prior approval from the Design System team.
 */

import React from 'react'
import { StyleProp, TextStyle } from 'react-native'
import { DefaultTheme } from 'styled-components/native'

import { ColorsType } from 'theme/types'
import { AccessibleIcon } from 'ui/svg/icons/types'

import { ButtonColors, ButtonSize, ButtonVariant } from './types'

export const getInteractiveColors = (colors: ButtonColors, isHoverActive: boolean) => ({
  backgroundColor:
    isHoverActive && colors.hoverBackgroundColor
      ? colors.hoverBackgroundColor
      : colors.backgroundColor,
  borderColor:
    isHoverActive && colors.hoverBorderColor ? colors.hoverBorderColor : colors.borderColor,
  textColor: isHoverActive && colors.hoverTextColor ? colors.hoverTextColor : colors.textColor,
  iconColor: isHoverActive && colors.hoverIconColor ? colors.hoverIconColor : colors.iconColor,
})

export const getBorderWidth = (borderColor?: ColorsType) => (borderColor ? 1 : 0)

export const getLabelText = (iconButton: boolean, wording?: string) =>
  iconButton ? undefined : wording

export const getLabelStyle = (
  textColor: ColorsType,
  fullWidth?: boolean,
  isMultiline?: boolean,
  hasIcon?: boolean
): StyleProp<TextStyle> => {
  const shouldExpand = (fullWidth || isMultiline) && !hasIcon
  const shouldCenter = fullWidth && !hasIcon

  return {
    color: textColor,
    maxWidth: '100%',
    minWidth: 0,
    flexShrink: 1,
    flexGrow: shouldExpand ? 1 : undefined,
    flexBasis: shouldExpand ? 0 : undefined,
    textAlign: shouldCenter ? 'center' : undefined,
  }
}

export const getSpacingGap = (hasLabel: boolean, spacing: number) => (hasLabel ? spacing : 0)

export const getTypographyForSize = (size: ButtonSize) => (size === 'small' ? 'ButtonS' : 'Button')

export const getContentPadding = ({
  variant,
  iconButton,
  theme,
}: {
  variant: ButtonVariant
  iconButton: boolean
  theme: DefaultTheme
}) => {
  if (iconButton) {
    const padding = theme.designSystem.size.spacing.s
    return { vertical: padding, horizontal: padding }
  }

  return {
    vertical: variant === 'tertiary' ? 0 : theme.designSystem.size.spacing.s,
    horizontal: variant === 'tertiary' ? 0 : theme.designSystem.size.spacing.m,
  }
}

export const getIconElement = ({
  icon: Icon,
  color,
  color2,
  size,
}: {
  icon?: React.FunctionComponent<AccessibleIcon>
  color: ColorsType | undefined
  color2: ColorsType
  size: number
}) => {
  if (!Icon) return null
  return <Icon color={color} color2={color2} size={size} />
}
